import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import useToast from 'hooks/useToast';

import { sendEvent } from 'lib/gtag';

/**
 * Campo clicável exibido ao lado do "Ir à loja" quando a oferta tem cupom.
 * Ao ser acionado copia o código pra área de transferência (não navega pra
 * loja). Layout inspirado no Pelando: borda tracejada, código em caixa alta,
 * ícone de copiar à direita.
 */
const CouponField = ({ className, coupon, gaEventCategory }) => {
  const { showToast } = useToast();

  const onCopy = async () => {
    sendEvent({ category: gaEventCategory, action: 'copy_coupon' });

    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(coupon);
      } else {
        // Fallback: selectionable textarea + execCommand. Mantém a UX quando
        // o navegador bloqueia Clipboard API por falta de contexto seguro.
        const textArea = document.createElement('textarea');
        textArea.value = coupon;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      showToast({ type: 'success', text: 'Cupom copiado!' });
    } catch {
      showToast({ type: 'danger', text: 'Não foi possível copiar o cupom' });
    }
  };

  return (
    <button
      aria-label={`Copiar cupom ${coupon}`}
      className={twMerge(
        'flex h-14 items-center justify-between gap-x-4 rounded-4 border-2 border-dashed border-neutral-high-500 bg-transparent px-4 transition-colors hover:bg-neutral-high-200 dark:border-neutral-high-400 dark:hover:bg-neutral-low-300',
        className
      )}
      type="button"
      onClick={onCopy}
    >
      <Text
        as="span"
        className="truncate text-lg font-bold uppercase text-neutral-low-500 dark:text-neutral-high-100"
        size="size1"
      >
        {coupon}
      </Text>
      <Icon
        aria-hidden="true"
        className="shrink-0 text-rd-primary-700 dark:text-rd-primary-700"
        name="copy"
        size="size2"
      />
    </button>
  );
};

CouponField.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  coupon: PropTypes.string.isRequired,
  gaEventCategory: PropTypes.string.isRequired,
};

export default CouponField;
